import store from '../redux/store'
import BaseTrackingProvider from './baseTrackingProvider'
import { v4 as uuidv4 } from 'uuid'

class ActivityTrackingService {
  loggedIn = false
  sessionId = uuidv4()
  /**
   * @type {BaseTrackingProvider[]}
   */
  providers = []
  /**
   * @type {BaseTrackingProvider[]}
   */
  pendingProviders = []
  /**
   * @type {null|number}
   */
  giataIdForEventsAndPageViews = null

  constructor () {
    store.subscribe(() => {
      let loggedIn = this._isLoggedIn()
      this._processNewLoginState(loggedIn)
    })
    this._processNewLoginState(this._isLoggedIn())
    window.addEventListener('ccm19WidgetClosed', () => {
      this._registerPendingProviders()
      this._disableNonConsentedTrackingProviders()
    })
  }

  setGiataIdForEventsAndPageViews (giataId) {
    this.giataIdForEventsAndPageViews = giataId
  }

  registerTrackingProvider (trackingProvider) {
    if (!trackingProvider instanceof BaseTrackingProvider) {
      throw new TypeError('Can only register trackers extending BaseTrackingProvider')
    }
    if (this.providers.indexOf(trackingProvider) !== -1) {
      return
    }
    if (!trackingProvider.hasConsented()) {
      this.pendingProviders.indexOf(trackingProvider) === -1 && this.pendingProviders.push(trackingProvider)
      return
    }
    trackingProvider.optIn()
    trackingProvider.setSessionId(this.sessionId)
    if (this.loggedIn) {
      trackingProvider.setUserId(this._getUserId())
    }
    this.providers.push(trackingProvider)
  }

  trackEvent (eventName, eventOpts = {}, injectGiataId = true) {
    if (injectGiataId === true && this.giataIdForEventsAndPageViews !== null) {
      eventOpts.giataId = this.giataIdForEventsAndPageViews
    }
    for (let i = 0; i < this.providers.length; i++) {
      const provider = this.providers[i]
      provider.trackEvent(eventName, eventOpts)
    }
  }

  trackPageView (pageName, pageOpts = {}, injectGiataId = true) {
    if (injectGiataId === true && this.giataIdForEventsAndPageViews !== null) {
      pageOpts.giataId = this.giataIdForEventsAndPageViews
    }
    for (let i = 0; i < this.providers.length; i++) {
      const provider = this.providers[i]
      provider.trackPageView(pageName, pageOpts)
    }
  }

  _processNewLoginState (loggedIn) {
    if (loggedIn === true) {
      const userId = this._getUserId()
      for (let i = 0; i < this.providers.length; i++) {
        const provider = this.providers[i]
        provider.setUserId(userId)
      }
    } else {
      this._disableAllTrackingProviders()
    }
    this.loggedIn = loggedIn
  }

  _getUserId () {
    return store.getState().user.userId
  }

  _registerPendingProviders () {
    for (let i = 0; i < this.pendingProviders.length; i++) {
      const pendingProvider = this.pendingProviders[i]
      this.registerTrackingProvider(pendingProvider)
    }
    this.pendingProviders = []
  }

  _isLoggedIn () {
    const user = store.getState().user
    return user?.loggedIn === true && user?.userId !== undefined
  }

  _disableNonConsentedTrackingProviders () {
    const remainingProviders = []
    for (let i = 0; i < this.providers.length; i++) {
      const provider = this.providers[i]
      if (provider.hasConsented()) {
        remainingProviders.push(provider)
        continue
      }
      try {
        provider.optOut()
      } catch (e) {
        console.error(e)
      }
      this.pendingProviders.push(provider)
    }
    this.providers = remainingProviders
  }

  _disableAllTrackingProviders () {
    for (let i = 0; i < this.providers.length; i++) {
      const provider = this.providers[i]
      try {
        provider.optOut()
      } catch (e) {
        console.error(e)
      }
      this.pendingProviders.push(provider)
    }
    this.providers = []
  }
}

const activityTrackingService = new ActivityTrackingService()
export default activityTrackingService
